export default "__VITE_ASSET__Dl$PBQ_a__"